<template>
	<div class="input flex">
		<input
			type="number"
			class="cap"
			placeholder="Inserisci il cap"
			:value="currentZip"
			@input="$emit('update:currentZip', $event.target.value)"
			max="5"
			name="zip"
			pattern="[0–9]{5}"
		>

		<div
			@click="geolocate"
			class="geomarker flex-right"
		>
			<i class="fas fa-map-marker-alt" />
		</div>
	</div>
</template>

<script type="text/javascript">
export default {
	props: {
		currentZip: {
			type: String,
			default: null
		}
	},

	methods: {
		geolocate () {
			this.$emit('geolocate')
		}
	}
}

</script>

<style>
	.input {
		z-index: 1;
		padding: 0;
	}

	input[name="zip"] {
		background: white;
		width: 100%;
		padding: 10px;
		border-bottom: 1.5px solid #ededed;
	}


	.cap {
		flex-basis: 100%;
	}

	.geomarker {
		background: #ededed;
		color: #575A5C;
		font-size: 20px;
		padding: 0 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}


input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type="number"] {
    -moz-appearance: textfield;
}

@media (max-width: 1024px) {
	input[name="zip"] {
		border-left: none;
		border-bottom: 1.5px solid #ededed;
	}
}

</style>